import i18n from '../../../i18n';
import HttpService from '../../../services/HttpService';
import { getLocation3CategoriesTreeWithCorrespondingChildren, GetSortOrder } from '../../helperFuncs';

export const getLevel1Options = async () => {
  const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/locations/parametrics/level1`);
  const options = resp?.data.data?.map((location: any) => {
    return {
      key: (location['o:title']),
      value: location['o:id']
    };
  });
  return i18n.language === 'en'
    ? options.sort(GetSortOrder('key'))
    : options.sort((a: any, b: any) => a.key.localeCompare(b.key, 'el'));
};

export const getLevel2Options = async () => {
  const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/locations/parametrics/level2`);
  const options = resp?.data?.data?.map((location: any) => {
    const x = location?.['dcterms:relation'];
    if (!x) return;
    return {
      key: location?.['o:title'],
      value: location?.['o:id'],
      parent: x[0].display_title
    };
  }).filter((value: any) => value);
  return i18n.language === 'en'
    ? options.sort(GetSortOrder('parent'))
    : options.sort((a: any, b: any) => a.parent.localeCompare(b.parent, 'el'));
};

export const getLevel3Options = async () => {
  const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/locations/parametrics/level3`);
  const options = getLocation3CategoriesTreeWithCorrespondingChildren(resp?.data.data);
  const options3 = options.map((option: any) => {
    return option.children.map((child: any) => {
      return {
        level1Id: option.level1Id,
        level1Title: option.level1Title,
        key: child.title,
        value: child.id,
        parent: option.title
      };
    });
  }).flat();
  return i18n.language === 'en'
    ? options3.sort(GetSortOrder('parent'))
    : options3.sort((a: any, b: any) => a.parent.localeCompare(b.parent, 'el'));
};

export const getRegions = async (query?: any) => {
  const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/professionals/parametrics/regions`, { params: query });
  const options = resp?.data['o:terms'];
  return i18n.language === 'en'
    ? options.sort(GetSortOrder('key'))
    : options.sort((a: any, b: any) => a.key.localeCompare(b.key, 'el'));
};

export const getRegionsOnly = async () => {
  const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/professionals/parametrics/regions_only`);
  const options = resp?.data['o:terms'];
  return i18n.language === 'en'
    ? options.sort(GetSortOrder('key'))
    : options.sort((a: any, b: any) => a.key.localeCompare(b.key, 'el'));
};

export const getApplLocationDetails = async (id: string) => {
  try {
    const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/applications/locations/${id}`);
    return resp.data;
  } catch (error) {
    console.error(error);
  }
};

export const getLocationDetails = async (id: string) => {
  try {
    const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/locations/omeka/${id}`);
    return resp.data;
  } catch (error) {
    console.error(error);
  }
};

export const getApplicationLocationDropdownOptions = async () => {
  const [level1, level2, level3, regionsOptions] = await Promise.all([
    getLevel1Options(),
    getLevel2Options(),
    getLevel3Options(),
    getRegions()
  ]);
  return { level1, level2, level3, regionsOptions };
};


export const uploadApplicationLocationForm = async (formData: FormData, options: any = null) => {
  try {
    return await HttpService.getAxiosClient().post(`${process.env.REACT_APP_BACKEND_URL}/locations`, formData, options);
  } catch (error) {
    console.error(error);
  }
};

export const updateApplicationLocationForm = async (formData: FormData, id: number) => {
  try {
    return await HttpService.getAxiosClient().put(`${process.env.REACT_APP_BACKEND_URL}/locations/${id}`, formData);
  } catch (error) {
    console.error(error);
  }
};

export const getAvalaibleUsersByAdminUnitId = async (administrative_unit_id: number) => {
  try {
    const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/users`, {
      params: {
        administrative_unit_id
      }
    });
    return resp.data;
  } catch (error) {
    console.error(error);
  }
};

export const getOfficeDetails = async () => {
  try {
    const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/users/keycloak`);
    return {
      ...resp?.data?.office?.[0],
      phone_number: resp?.data?.office_category === 'ekome'
        ? resp?.data?.office?.[0]?.phone
        : resp?.data?.office?.[0]?.phone_number,
      office_category: resp?.data?.office_category,
      region_id: resp?.data?.usr_administrative_unit?.loc_regional_unit_municipalities?.id
    };
  } catch (error) {
    console.error(error);
  }
};

export const getInternalDetails = async () => {
  try {
    const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/users/keycloak`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getOriginalWatermarkImage = async (id: string, title?: string) => {
  try {
    const imageName = !title
      ? 'thumbnail.jpg'
      : title;
    const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/locations/images/${id}?title=${imageName}`);
    return resp.data;
  } catch (error) {
    console.error(error);
  }
};